import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold font-size-18 mb-8" }
const _hoisted_2 = { class: "mb-1 font-size-18 font-bold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_4 = { class: "mb-4 font-size-14" }
const _hoisted_5 = { class: "mb-4 bg-color-f8 px-6 py-4 font-size-14" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "flex text-light-blue items-center" }
const _hoisted_8 = { class: "flex text-light-blue items-center cursor-pointer mr-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-download mr-1 text-2xl" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-download mr-1 text-2xl" }, null, -1)
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-upload text-2xl mr-2" }, null, -1)
const _hoisted_14 = { class: "text-grey-999 font-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Button = _resolveComponent("Button")
  const _component_InputFile = _resolveComponent("InputFile")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_UploadFileImportShiftPlanPopup = _resolveComponent("UploadFileImportShiftPlanPopup")
  const _component_ImportingShiftPlanPopup = _resolveComponent("ImportingShiftPlanPopup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.backShiftPlanRegister }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('shiftPlan')) + "：" + _toDisplayString(_ctx.t('signUp')), 1),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('importShiftData')), 1),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.t('importTheCSVFileAndRegisterTheShift')), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, _toDisplayString(_ctx.t('exportShiftPlanNote')), 1),
            _createVNode("div", null, _toDisplayString(_ctx.t('exportShiftPlanNote2')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", null, _toDisplayString(_ctx.t('templateFile')), 1)
            ]),
            _createVNode("a", {
              class: "flex text-light-blue items-center cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportShiftPlan && _ctx.exportShiftPlan(...args)))
            }, [
              _hoisted_10,
              _createVNode("div", null, _toDisplayString(_ctx.t('currentShiftData')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_InputFile, {
              modelValue: _ctx.importShiftPlanParams.import_file,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.importShiftPlanParams.import_file = $event)),
              onOnChange: _ctx.openUploadFileImportShiftPlanPopup
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  variant: "outline-primary",
                  class: "mr-4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('fileSelection')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onOnChange"]),
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('fileSizeLimit')) + ": 10MB、" + _toDisplayString(_ctx.t('extension')) + ":CSV ", 1)
          ]),
          _createVNode(_component_ErrorMessage, {
            "error-message": _ctx.errors.import_file
          }, null, 8, ["error-message"])
        ]),
        _createVNode(_component_Button, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('backToIndex')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_UploadFileImportShiftPlanPopup, {
      modelValue: _ctx.isShowUploadFileImportShiftPlanPopup,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowUploadFileImportShiftPlanPopup = $event)),
      file: _ctx.importShiftPlanParams.import_file,
      loading: _ctx.loadingImportShiftPlanDraft,
      "import-shift-plan-draft-detail": _ctx.importShiftPlanDraftDetail,
      onOnSubmit: _ctx.submitImportShiftPlan,
      onOnClose: _ctx.closeUploadFileImportShiftPlanPopup
    }, null, 8, ["modelValue", "file", "loading", "import-shift-plan-draft-detail", "onOnSubmit", "onOnClose"]),
    _createVNode(_component_ImportingShiftPlanPopup, {
      modelValue: _ctx.isShowImportingShiftPlanPopup,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowImportingShiftPlanPopup = $event)),
      loading: _ctx.loadingImportShiftPlan,
      "import-shift-plan-draft-detail": _ctx.importShiftPlanDraftDetail,
      onOnSubmit: _ctx.submitAbortImportShiftPlan
    }, null, 8, ["modelValue", "loading", "import-shift-plan-draft-detail", "onOnSubmit"])
  ], 64))
}